module.exports = __webpack_public_path__ + "img/project-tasks-remaining.6d6ecb50.svg";